(function() {
  'use strict';

  angular.module('ringbaPortal').component('bulkTagsUploader', {
    bindings: {
      tagId: '<',
      tagIds: '<',
      filter: '<',
      andIndex: '<',
      orIndex: '<',
      comparison: '<',
      onTagChange: '<',
      bulkTagUploads: '<',
      isRequired: '<',
      uploadSettings: '<',
      selectedBulkTagUpload: '<',
      onNewUpload: '&',
      setDuplicateWarning: '&'
    },
    controller: BulkTagsUploaderController,
    controllerAs: 'vm',
    templateUrl:
      '/scripts/shared/components/bulk-tags-uploader/bulk-tags-uploader.view.html'
  });

  function BulkTagsUploaderController(
    $filter,
    $translate,
    $scope,
    accountsService,
    bsLoadingOverlayService,
    bulkTagsService,
    comparisonTypeService,
    tagsValuesService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.tagSearchLoader = 'tagSearchLoader';
    vm.tagUploadLoader = 'tagUploadLoader';
    vm.tagUploaderTooltip = $filter('translate')('BULK_UPLOAD_TT');
    vm.numberRegex = /^\d+$/;
    vm.showTagDropdown = false;

    vm.$onChanges = onChanges;
    vm.onBulkTagChanged = onBulkTagChanged;
    vm.uploadValues = uploadValues;
    vm.searchTag = searchTag;
    vm.toggleSearchInput = toggleSearchInput;
    vm.onDropdownOpenClose = onDropdownOpenClose;
    vm.onStartLoadingBulkTags = onStartLoadingBulkTags;

    function onChanges(changesObj) {
      vm.clicked = false;
      vm.showSearchTag = false;

      if (vm.tagCriteria && changesObj.comparison) {
        vm.tagCriteria.Id = undefined;
        vm.tagCriteria.value = undefined;
      }

      if (vm.filter && vm.filter.tagCriteria) {
        _handleTagChanges();
      }

      if (changesObj.selectedBulkTagUpload) {
        vm.bulkTagId = vm.selectedBulkTagUpload;
      }

      vm.showTagDropdown = _showOrHideTagValueDropdown(
        vm.tagId,
        vm.tagIds,
        vm.tagCriteria
      );
    }

    function onStartLoadingBulkTags() {
      $scope.$emit('onLoadingBulkTags', true);
      _showUploadLoader(true);
    }

    function onFinishedLoadingBulkTags() {
      $scope.$emit('onLoadingBulkTags', false);
      _showUploadLoader(false);
    }

    function onBulkTagChanged(selectedFile) {
      vm.tagCriteria.Id = selectedFile.id;
      vm.tagCriteria.hasMultipleValues = true;
      vm.tagCriteria.value = selectedFile.name;

      vm.onTagChange(vm.filter, vm.andIndex, vm.orIndex, selectedFile.id);
      onFinishedLoadingBulkTags();
    }

    function uploadValues(file) {
      if (file) {
        _showUploadLoader(true);
        bulkTagsService
          .uploadValues(
            accountsService.currentAccountId,
            file,
            _getUploadSettings()
          )
          .then(function(response) {
            // Check if backend detected duplicate content
            if (response.data.duplicateDetected) {
              vm.setDuplicateWarning({
                andIndex: vm.andIndex,
                orIndex: vm.orIndex,
                fileName: response.data.bulkTagUpload.name
              });
            } else {
              // New file created
              vm.bulkTagUploads.push(response.data.bulkTagUpload);
              toaster.pop(
                'success',
                $translate.instant('BULK_TAGS_UPLOAD_SUCCESS')
              );
              vm.onNewUpload({ bulkTagUpload: response.data.bulkTagUpload });
            }
            onBulkTagChanged(response.data.bulkTagUpload);
          })
          .catch(utils.errorHandler)
          .finally(function() {
            _showUploadLoader(false);
          });
      }
    }

    function searchTag(tag) {
      vm.searchTagExists = undefined;

      if (!tag) {
        return;
      }

      _makeLoaderVisible(true, vm.tagSearchLoader);

      return bulkTagsService
        .checkTagExistsInUpload(
          accountsService.currentAccountId,
          tag,
          vm.selectedBulkTagUpload
        )
        .then(function(response) {
          vm.searchTagExists = response.data.exists;
        })
        .catch(utils.errorHandler)
        .finally(function() {
          _makeLoaderVisible(false, vm.tagSearchLoader);
        });
    }

    function toggleSearchInput() {
      vm.showSearchTag = !vm.showSearchTag;
    }

    function onDropdownOpenClose(isOpen) {
      vm.clicked = !isOpen;
    }

    function _showOrHideTagValueDropdown(tagId, tagIds, tagCriteria) {
      return (
        tagsValuesService.checkIfDropdownToBeShown(tagId, tagIds) &&
        comparisonTypeService.showDropdownValues(tagCriteria.comparisonType)
      );
    }

    function _showUploadLoader(show) {
      vm.uploadingTags = show;
      _makeLoaderVisible(show, vm.tagUploadLoader);
    }

    function _makeLoaderVisible(visible, loaderRef) {
      if (visible) {
        bsLoadingOverlayService.start({
          referenceId: loaderRef
        });
      } else {
        bsLoadingOverlayService.stop({
          referenceId: loaderRef
        });
      }
    }

    function _handleTagChanges() {
      vm.tagCriteria = vm.filter.tagCriteria[vm.orIndex];
      vm.tagCriteria.isBulkTag = true;

      if (
        vm.tagCriteria &&
        (vm.tagCriteria.Id ||
          _canShowBulkTagUploader(vm.tagCriteria.comparisonTypeTemp) ||
          _canShowBulkTagUploader(vm.tagCriteria.comparisonTypeTemp.value))
      ) {
        vm.valueType = 'bulk';
        vm.tagCriteria.hasMultipleValues = true;
      } else {
        vm.valueType = 'single';
        vm.tagCriteria.hasMultipleValues = false;
      }
    }

    function _canShowBulkTagUploader(comparisonTypeTemp) {
      return comparisonTypeService.isBulkTagComparison(comparisonTypeTemp);
    }

    function _getUploadSettings() {
      if (!vm.uploadSettings) {
        return undefined;
      }

      if (vm.uploadSettings == 'AreaCode') {
        return {
          convertToAreaCode: true,
          storeOriginalZipcodes: false
        };
      }

      if (vm.uploadSettings == 'AreaCodeAndZipCode') {
        return {
          convertToAreaCode: true,
          storeOriginalZipcodes: true
        };
      }

      return {
        storeOriginalZipcodes: true
      };
    }

  }
})();
